$(document).ready( function() {

    /*
        Built in such a way that it remembers the menu a user has selected for a different branch for when they go back to selecting that branch. Consists of Branch selectors and menus selectors. All content loaded on page with different data id's to match the buttons.
     */
     //console.log('Im compiled');
    /* MAIN Menu Nav */
    $('.menu_main_nav li').click(function() {

        removeActiveMainMenuClasses();
        $(this).addClass('current_menu');


        hideAllSubMenus();
        $('[data-menu-id="' + $(this).attr('data-id-selector') + '"]').addClass('menu_sub_nav--active');
        $('[data-mobile-menu-id="' + $(this).attr('data-id-selector') + '"]').addClass('menu_mobile--active');

        hideAllMenus();
        $('[data-menu-details-id=' + $(this).attr('data-id-selector') + ']').addClass('menus--active');


        $('.menus--active .menu__container__fooditems').each(function() {

            if( $(this).attr('data-menu-item-id') == $('.menu_sub_navitem--active').attr('data-menu-selector-id') ) {
                $(this).addClass('menu__container__fooditems--active');
            }
        });
    });

    /*
        REMOVE MAIN MENU CLASSES - Branches
    */
    function removeActiveMainMenuClasses() {
        $('.menu_main_nav li').removeClass('current_menu');
    }


    /*
        HIDE ALL SUB MENUS - Hide UL
     */
    function hideAllMenus() {
        $('.menus--active menu__container__fooditems').removeClass('menu__container__fooditems--active');
        $('.menus--active').removeClass('menus--active');
        
    }

    /*
        HIDE ALL SUB MENUS - Hide UL
     */
    function hideAllSubMenus() {
        $('.menu_sub_nav').removeClass('menu_sub_nav--active');
        $('.menu_mobile').removeClass('menu_mobile--active');
    }

    /*
        REMOVE SUB MENU CLASSES - List items Breakfast/Lunch e.c.t
    */
    function removeActiveSubMenuClasses() {
        $('.menu_sub_nav--active li').removeClass('menu_sub_navitem--active');
        $('.menu_mobile').removeClass('menu_mobile--active');
    }

    /*
        REMOVE SUB MENU CLASSES - List items Breakfast/Lunch e.c.t
    */
    function removeActiveMenuTypeClasses() {
        $('.menus--active .menu__container__fooditems').removeClass('menu__container__fooditems--active');
        
    }





    /* SUB Menu Nav */
    $('.menu_sub_nav li').click(function() {

        removeActiveSubMenuClasses();
        $(this).addClass('menu_sub_navitem--active');

        removeActiveMenuTypeClasses();
        $('[data-menu-item-id="' + $(this).attr('data-menu-selector-id') + '"]').addClass('menu__container__fooditems--active');



    });

    /* Mobile Menu Nav */
    $('select.menu_mobile').change(function() {
        removeActiveSubMenuClasses();
        $(this).addClass('menu_mobile--active');
        removeActiveMenuTypeClasses();
        $('[data-menu-item-id="' + $(this).val() + '"]').addClass('menu__container__fooditems--active');
    });


    /* As the food menus are tabbed content, it's difficult to link directly to that tab. The below javascript attempts to make it easy using an anchor tag */
    var hash = window.location.hash.substr(1);

    if(hash) {
        $('.menu_main_nav li[data-id-selector="'+hash+'"]').trigger('click');
    }

});


// WEBPACK FOOTER //
// ./menu.js